<template>
  <div id="index">
<!--    <dv-full-screen-container class="bg" >-->
<!--    <div class="bg">-->
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <router-link to='/'>
        <div class="d-flex jc-center">
          <img src="../assets/top.png" style="width: 100%"/>
        </div>
        </router-link>
        <!-- 第二行 -->
        <div class="d-flex jc-between px-2" style="position: relative;
    margin-top: -1rem;z-index: -1">
          <div class="d-flex" style="width: 40%">
          </div>
          <div style="width: 40%" class="d-flex">
            <div class="react-left  mr-3">
<!--              <span class="text fw-b">vue-big-screen</span>-->
            </div>
            <div
              class="react-left mr-4"
              style="width: 6.25rem; background-color: #0f1325; text-align: right;color: #fff"
            >
              <span class="react-after"></span>
              <span class="text">{{dateYear}}{{dateDay}}</span>
            </div>
          </div>
        </div>

        <div class="body-box">
          <!-- 第一列数据 -->
          <div class="content-box">

            <div class="column3">
              <h2 class="titleMax pos"><i class="iconfont icon-kucun-copy"></i>创新资源聚集地</h2>
              <div class="bg-border" style="height: 3.5rem">
                <div class="bg-border-inner" >
                  <Science />
                </div>
              </div>
              <div class="bg-border" style="height: 4rem">
                <div class="bg-border-inner" >
                  <Mall/>
                </div>
              </div>

            </div>
            <!-- 第二列数据 -->
            <div class="column4">
              <div style="height: 8rem">
                <Map/>
              </div>

            </div>
            <!-- 第三列数据 -->

            <div class="column3">
              <h2 class="titleMax pos"><i class="iconfont icon-kucun-copy"></i>科创成效集散地</h2>
              <div class="bg-border" style="height: 3rem;">
                <div class="bg-border-inner" >
                  <Achievement/>
                </div>
              </div>

              <div class="bg-border" style="height: 4.5rem">
                <div class="bg-border-inner" >
                  <Technology />
                </div>
              </div>

            </div>
          </div>
          <h2 class="titleMax mt-2"><i class="iconfont icon-kucun-copy"></i>创新主体培育基地</h2>
          <div class="bottom-box">
            <div class="column3">
              <div class="bg-border" style="height: 3.5rem">
                <div class="bg-border-inner" >
<!--                  <ul class="btnList">-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==0}">巴南分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==1}">两江协同创新区分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==2}">梁平分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==3}">开州分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==4}">潼南分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==5}">綦江分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==6}">铜梁分支基地</div></li>-->
<!--                    <li><div class="grid-content bg-purple" :class="{active:index==7}">科学城分支基地</div></li>-->
<!--                  </ul>-->

                  <el-row :gutter="20" class="btnList4">
                    <div class="d-flex pt-2 pl-2" style="margin-bottom:0.2rem">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">分支基地</span>
        </span>
                    </div>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==0}" @click="show(0)">巴南分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==1}" @click="show(1)">两江协同创新区分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==2}" @click="show(2)">梁平分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==3}" @click="show(3)">开州分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==4}" @click="show(4)">潼南分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==5}" @click="show(5)">綦江分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==6}" @click="show(6)">铜梁分支基地</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple" :class="{active:index==7}" @click="show(7)">科学城分支基地</div></el-col>
                  </el-row>
                </div>
              </div>
            </div>
              <div class="column4">
              <div class="bg-border" style="height: 3.5rem">
                <div class="bg-border-inner" >
                  <Activity />
                </div>
              </div>
              </div>
            <div class="column3">
              <div class="bg-border" style="height: 3.5rem">
                <div class="bg-border-inner" >
                  <Subject/>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
<!--    </dv-full-screen-container>-->
    </div>
</template>

<script>
import { formatTime } from '../utils/index.js'
// import Base from "../components/newbase/base";
import Activity from "@/components/newbase/activity";
import Map from "@/components/newbase/map";
import Science from "@/components/newbase/science";
import Achievement from "@/components/newbase/achievement";
import Subject from "@/components/newbase/subject";
import Mall from "@/components/newbase/mall";
import Technology from "@/components/newbase/technology";
export default {
  data () {
    return {
      index:null,
      pieOutline: '',
      key : 1,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    };
  },
  components: {
    // Base,//分支基地
    Activity,//创新活动
    Map,//地图
    Science,//科技政策
    Achievement,//成果转化
    Subject,//创新主体
    Mall,//易智商城
    Technology//技术交易
  },
  watch:{
    typeList:{
      handler() {
        this.region=this.typeList.name
        this.$store.commit('setregion',this.region)
      }
    }
  },
  computed:{
    typeList(){
      return this.$store.state.typeList;
    }

  },
  mounted () {
    this.index = this.$route.params.index;
    this.$store.commit('setdata',this.index)
    this.timeFn();
    this.cancelLoading();
    this.$store.commit('setcdata',
   [
          {
            name: "渝北区",
            value: 99,
          },
          {
            name: "万州区",
            value: 3
          },
          {
            name: "黔江区",
            value: 8
          },
          {
            name: "涪陵区",
            value: 7
          },
          {
            name: "渝中区",
            value:100
          },
          {
            name: "大渡口区",
            value: 100
          },
          {
            name: "江北区",
            value: 100
          },
          {
            name: "沙坪坝区",
            value: 100
          },
          {
            name: "九龙坡区",
            value: 100
          },
          {
            name: "南岸区",
            value: 100
          },
          {
            name: "北碚区",
            value: 100
          },
          {
            name: "綦江区",
            value: 7
          },
          {
            name: "大足区",
            value: 6
          },

          {
            name: "巴南区",
            value: 99
          },
          {
            name: "长寿区",
            value: 2
          },
          {
            name: "江津区",
            value: 1
          },
          {
            name: "合川区",
            value: 3
          },
          {
            name: "永川区",
            value: 6
          },
          {
            name: "南川区",
            value: 7
          },
          {
            name: "璧山区",
            value: 9
          },
          {
            name: "铜梁区",
            value: 7
          },
          {
            name: "潼南区",
            value: 99
          },
          {
            name: "荣昌区",
            value: 4
          },
          {
            name: "开州区",
            value: 99
          },
          {
            name: "梁平区",
            value: 99
          },
          {
            name: "武隆区",
            value: 6
          },
          {
            name: "城口县",
            value: 2
          },
          {
            name: "丰都县",
            value: 8
          },
          {
            name: "垫江县",
            value: 7
          },
          {
            name: "忠县",
            value: 3
          },
          {
            name: "云阳县",
            value: 5
          },
          {
            name: "奉节县",
            value: 2
          },
          {
            name: "巫山县",
            value: 8
          },
          {
            name: "巫溪县",
            value: 5
          },
          {
            name: "石柱县",
            value: 9
          },
          {
            name: "秀山县",
            value: 1
          },
          {
            name: "酉阳县",
            value: 9
          },
          {
            name: "彭水县",
            value: 1
          }]
      )
  },
  methods: {
    show(i){
      this.index=i
      this.$store.commit('setdata',this.index)
    },
    timeFn () {
      setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss');
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000)
    },
    cancelLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';
.titleMax{
  height: 40px;
  font-size: 28px;
  font-weight: normal;
  line-height: 40px;
  margin-bottom: 0.2rem;
  color:#ffdb5c;
  text-align: left;
  border-bottom: 1px solid #4c9bfd;
}.mt-2{
  margin-top: -15px;
 }
.pos{
  position: absolute;
  top: -60px;
  width: 100%;
}
.titleMax i{
  font-size: 40px;
  line-height: 40px;
  margin-right: 10px;
  vertical-align: middle;
}

.btnList4{
  padding: 0.2rem;
  width: 100%;
  margin: 0!important;
}
.btnList4 .grid-content{
  height: 0.5rem!important;
  flex: 1;
  text-align: center;
  font-size: 20px;
  margin-bottom: 10px;
 line-height: 0.5rem;
  border-radius: 0.1rem;
  color: #ffffff;
  background:#142957;
}
.btnList4 .grid-content.active{
  background:#018fff!important;
  color: #fff!important;
}
.btnList4 .grid-content:hover{
  background:#018fff;
  color: #fff!important;
}
</style>